import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { motion } from "framer-motion";
import COLORS from "../../constants/colors";

// Props: message (string), subtext (string, optional)
const PageLoader = ({ message = "Loading...", subtext = "" }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="70vh"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={1} // spacing between spinner and text
        >
          {/* Spinner */}
          <CircularProgress
            size={20}
            thickness={2}
            sx={{ color: COLORS.primary }}
          />

          {/* Main message */}
          <Typography
            sx={{
              mt: 1,
              fontSize: "0.8rem",
              fontWeight: 600,
              color: "text.primary",
            }}
          >
            {message}
          </Typography>

          
        </Box>
      </motion.div>
    </Box>
  );
};

export default PageLoader;
